import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Dashboard } from './Dashboard';

function App() {
  return (
    <Dashboard />
  );
}

export default App;
